const firebase = require('firebase');
// Required for side-effects
require('firebase/firestore');
require('firebase/functions');

firebase.initializeApp({
  apiKey: 'AIzaSyA2oy975LtgFzy-ZJGhYtu1dSp00tJGKAE',
  authDomain: 'sunny-b-solar.firebaseapp.com',
  databaseURL: 'https://sunny-b-solar.firebaseio.com',
  projectId: 'sunny-b-solar',
  storageBucket: 'sunny-b-solar.appspot.com',
  messagingSenderId: '152611592013',
});

// Initialize Cloud Firestore through Firebase
const db = firebase.firestore();

// Initialize Cloud functions
const cloudFunctions = firebase.functions();

export { db, cloudFunctions };



// WEBPACK FOOTER //
// ./src/startup/db_init.js